import React from 'react';
import Footer from '../../../Shared/Footer/Footer';
import TopBar from '../../../Shared/Topbar/TopBar';
import AboutUs from '../AboutUs/AboutUs';
import ClientArea from '../ClientArea/ClientArea';
import ContactUs from '../ContactUs/ContactUs';
import OnGoingProjects from '../OnGoingProjects/OnGoingProjects/OnGoingProjects';
import OurServices from '../OurServices/OurServices';
import Projects from '../Projects/Projects/Projects';
import Loading from '../../../Shared/Loading/Loading';
import OurTeam from '../OurTeam/OurTeam';
import SisterConcern from '../SisterConcern/SisterConcern';

const Home = (props) => {

    const isLoading = props.logos.length >= 3

    return (

        <>
            {isLoading ? <div>
                <TopBar banner={props.banner} />
                <AboutUs />
                <Projects projects={props.ourProjects} />
                <OnGoingProjects onGoingProjects={props.onGoingProjects} />
                <OurServices />
                <OurTeam team={props.team} />
                <SisterConcern />
                <ContactUs />
                <ClientArea comment={props.comments} logo={props.logos} />
                <Footer />
            </div> : <Loading />}

        </>
    );
};

export default Home;